import WalkthroughCoordinator from './walkthrough_coordinator';

export default WalkthroughCoordinator;
